// Filename: uiarticle.js
// Timestamp: 2017.11.19-13:41:52 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import uitagslist from './uitagslist.js'

const xvnode = (sess, cfg, gr, nd, pg, subj) => {
  const { div, h1, ul, li, a, span } = cfg.h(pg, nd)
  const {
    title,
    author,
    typelabel,
    typehref,
    datepublished,
    content,
    tagslabel,
    tagslist
  } = subj

  return (
    div('.:ui-root', [
      h1('.:ui-head', title),
      ul('.:ui-details', [
        li('.:ui-details-item', author),
        li('.:ui-details-item', [
          a('.:ui-details-item-typelink', {
            href: typehref,
            title: typelabel
          }, typelabel)
        ]),
        li('.:ui-details-item.date-label', datepublished)
      ]),
      div('.:ui-content.readable', {
        dangerouslySetInnerHTML: {
          __html: content
        }
      }),
      div('.:ui-tags', [
        span('.:ui-tags-label', tagslabel),
        uitagslist.xvnode(sess, cfg, gr, nd, uitagslist, {
          tags: (tagslist && tagslist.length)
            ? tagslist
            : ['none']
        })
      ])
    ])
  )
}

export default {
  type: 'uiarticle',
  xvnode
}
